var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.427 1.451a2.29 2.29 0 0 1 4.036.112l.178.356c.371.743.465 1.596.263 2.402l-.336 1.347h2.304a2.5 2.5 0 0 1 2.321 3.429l-2 5a2.5 2.5 0 0 1-2.321 1.571H7.334a.83.83 0 0 1-.463-.14l-1.204-.803v.11c0 .46-.373.833-.833.833H1.5a.833.833 0 0 1-.833-.833V5.668c0-.46.373-.833.833-.833h3.334c.46 0 .833.373.833.833h.35zm-.841 12.55-1.919-1.279V7.335H6.5c.3 0 .575-.16.724-.42l2.65-4.637a.623.623 0 0 1 1.098.03l.178.356c.194.388.243.832.137 1.253l-.437 1.751H9.834v1.667h5.038c.59 0 .993.595.774 1.143l-2 5a.83.83 0 0 1-.774.524zm-5.252-7.5v7.5H4v-7.5z",
    clipRule: "evenodd"
  })));
};
export default SvgLike;